import styled from 'styled-components';

import { LeadIntentFlag } from '../../../../Model/Lead';
import Select from '../../../../../components/v2/Select';
import colors from '../../../../../styles/colors';

const ModalContent = styled.div`
  margin-bottom: 20px;
  padding: 10px 40px;
`;

const RecordOutcomeSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 20px 0 10px;
`;

const StyledSelectField = styled(Select)`
  align-self: end;
  height: 40px;
  width: 100%;
  margin-bottom: 15px;
`;

const PreviousAttemptsList = styled.div`
  margin-bottom: 12px;
`;

const PreviousAttemptItem = styled.div`
  margin: 4px 0;
  color: ${colors.shades.beta1};
  font-size: 14px;
`;

const OutcomeNoteSection = styled.div`
  margin-top: 8px;
`;

const FollowUpDateTimeSection = styled.div`
  margin-bottom: 15px;
`;

const intentFlagDotColor = {
  [LeadIntentFlag.GREEN]: colors.shades.success3,
  [LeadIntentFlag.AMBER]: colors.shades.warning3,
  [LeadIntentFlag.RED]: colors.shades.danger3,
};

const IntentFlagOption = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IntentFlagDot = styled.span`
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ $flag }) => intentFlagDotColor[$flag]};
`;

export {
  StyledSelectField,
  RecordOutcomeSection,
  ModalContent,
  PreviousAttemptsList,
  PreviousAttemptItem,
  OutcomeNoteSection,
  FollowUpDateTimeSection,
  IntentFlagOption,
  IntentFlagDot,
};
